export class SideNavTreeInfo {
    id: string;
    parentId: string;
    name: string;
    text: string;
    path?: string;
    icon? = '';
    value?: string;
    tooltip?: string;
    items?: SideNavTreeInfo[] = [];
    params?: string;
    selected? = false;
    expanded? = false;
    dynamic? = false;
    visible? = true;
    isInternal? = false;
    isSpecificRole? = false;
    isWorkspace? = false;
    hasAccess? = false; // Only used to control the bottom menu access
    openInNewWindow? = false; // Only used to open navigation in new window
}
